<template>
  <Modal
    :title="'Recusar Proposta'"
    :active="modalActive"
    @close="$emit('close')"
    data-testId="refusal-reason-popup"
  >
    <ValidationObserver ref="refusalFormValidator" v-slot="{ invalid }">
      <ValidationProvider
        name="Motivo de Recusa"
        rules="required"
        v-slot="{ errors }"
      >
        <label for="refusal-reason-select" class="vs-select--label"
          >Motivo de Recusa</label
        >
        <v-select
          :options="motives"
          id="refusal-reason-select"
          :class="{ 'has-error': errors.length }"
          v-model="refusalForm.motiveId"
          :reduce="(option) => option.id"
          data-testId="refusal-reason-select"
        />
      </ValidationProvider>
      <vs-textarea
        class="mb-2 my-5"
        placeholder="Insira uma observação sobre a Recusa"
        v-model="refusalForm.refusalObs"
        data-testId="refusal-obs-textarea"
      />
      <vs-button
        @click="refuseProposal()"
        :disabled="invalid"
        color="success"
        class="mb-2 my-5 ml-2"
        data-testId="refusal-reason-popup-save-button"
      >
        <span>Salvar</span>
      </vs-button>
    </ValidationObserver>
  </Modal>
</template>

<script>
import vSelect from 'vue-select';
import notify from '../../utils/notify';
import Modal from '../../components/Modal.vue';
import { TIPOS_APOLICES } from '../../utils/constants';
import lifeService from '../../services/life-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import services from '../../services';

export default {
  components: {
    'v-select': vSelect,
    Modal,
    ValidationObserver,
    ValidationProvider,
  },
  props: ['policyId', 'policyTypeId', 'active'],
  computed: {
    modalActive() {
      return this.active;
    },
  },
  data() {
    return {
      motives: [],
      refusalForm: {
        refusalObs: null,
        motiveId: null,
      },
    };
  },
  mounted() {
    this.getMotives();
  },
  methods: {
    async getMotives() {
      services.getAll('g', {}, `domMotivoRecusaProposta/list/`).then((res) => {
        res.data.forEach((element) => {
          this.motives.push({
            id: element.idMotivo,
            label: element.nomeMotivo,
          });
        });
      });
    },
    async refuseProposal() {
      const valid = await this.$refs.refusalFormValidator.validate();
      if (!valid) return;

      try {
        const { motiveId, refusalObs } = this.refusalForm;
        const vida = this.policyTypeId === TIPOS_APOLICES.VIDA;
        const auto = this.policyTypeId === TIPOS_APOLICES.AUTO;
        const rcvat = this.policyTypeId === TIPOS_APOLICES.RCVAT;

        this.$vs.loading();
        if (vida) {
          await lifeService.refuseProposalAdmin(
            this.policyId,
            motiveId,
            refusalObs,
          );
        } else if (auto || rcvat) {
          const controller = auto ? 'Auto' : 'rcvat';
          const action = 'refuse/' + this.policyId;
          const data = {
            reasonId: motiveId,
            description: refusalObs,
          };
          await lifeService.update(controller, data, action);
        }
        this.$emit('close');
        this.$emit('handleProposalRefused');
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao recusar a proposta');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
